import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-no-passports',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="no-passports-container">
      <div class="no-passports-content">
        <div class="icon-wrapper">
          <div class="icon-circle-blur"></div>
          <img src="/assets/images/No_Passports_Icon.png" alt="No Passports" class="no-passports-icon">
        </div>
        <div class="no-passports-text">No Passports Yet</div>
      </div>
    </div>
  `,
  styles: [`
    .no-passports-container {
      position: relative;
      width: 100%;
      min-height: 400px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px 16px;
    }

    .no-passports-content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 17px;
    }

    .icon-wrapper {
      position: relative;
      width: 138px;
      height: 138px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .icon-circle-blur {
      position: absolute;
      width: 138px;
      height: 138px;
      background: #FFFFFF;
      border-radius: 50%;
      filter: blur(2px);
      z-index: 0;
    }

    .no-passports-icon {
      position: relative;
      width: 56px;
      height: 56px;
      z-index: 1;
    }

    .no-passports-text {
      font-family: 'Lato', sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 20px;
      color: #000000;
      text-align: center;
    }
  `]
})
export class NoPassportsComponent {}

